<script setup>
const props = defineProps({
  done: {
    type: Boolean,
    default: false,
  },
  small: {
    type: Boolean,
    default: false,
  },
});

const dotPosition = dot => {
  const positions = props.small
    ? ['left-1 top-1', 'right-1 top-1', 'bottom-1 left-1/2 -translate-x-1/2']
    : ['left-2 top-2', 'right-2 top-2', 'bottom-2 left-1/2 -translate-x-1/2'];

  return positions[dot - 1];
};
</script>

<template>
  <span
    class="relative inline-grid shrink-0 place-items-center"
    :class="small ? 'size-5' : 'size-9'"
    aria-hidden="true"
  >
    <span
      v-for="dot in 3"
      :key="dot"
      class="absolute rounded-full"
      :class="[
        'bg-n-ruby-9',
        small ? 'size-1.5' : 'size-2',
        dotPosition(dot),
      ]"
    />
  </span>
</template>
